import React from 'react'
import Loader from 'react-loader-spinner'
import { Modal } from 'react-bootstrap'
import './Spinner.scss'
//import CircularProgress from '@material-ui/core/CircularProgress'
export default class CustomSpinner extends React.Component {
	render() {
		return (
			<div>
				<Modal
					//className='loadingSpinner'
					show={this.props.showModal}
					onHide={this.handleClose}
					animation={false}
				    className='loadingBackdrop'
				>

					<Modal.Body className='modalBody noPadding'>
						<div className='verticalMiddle'>
							<Loader type='TailSpin' color='#E39381' height={80} width={80} visible={true} />
							{/* <CircularProgress color='secondary' className='spinnerSize' /> */}
						</div>
					</Modal.Body>
				</Modal>
			</div>
		)
	}
}

